<template>
  <NuxtLayout>
    <div>
      <div>
        <ZeroResultsContainer
          heading-message="Page Not Found"
          secondary-message="We're sorry, the page you requested could not be found. Please go back to the homepage"
          action="Go Back"
          @action-clicked="navigateTo({ path: '/' })"
        >
          <Svg404 />
        </ZeroResultsContainer>
      </div>
    </div>
  </NuxtLayout>
</template>

<script setup>
const props = defineProps({
  error: {
    type: Object,
    required: true,
  },
});
</script>
